<section class="d-flex justify-content-center align-items-center width-100p height-100p">
    <img style="height: 50%" src="assets/imgs/404.png" alt="" />
</section>
